const DEFAULT_DEV_API_URL = 'http://localhost:5000';

/**
 * Base URL do backend (sem barra no final).
 * Produção usa sempre o proxy no próprio domínio para que os cookies HttpOnly
 * sejam first-party. A variável externa é aceita apenas no desenvolvimento/teste.
 */
export const getApiBaseUrl = (environment = process.env.NODE_ENV) => {
  if (environment === 'production') return '/api';
  const fromEnv = String(process.env.REACT_APP_API_URL || '').trim().replace(/\/+$/, '');
  if (fromEnv) return fromEnv;
  return DEFAULT_DEV_API_URL;
};

export default getApiBaseUrl;
